import { ANALYSIS_STATUS, IMMIGRATION_OPTIONS } from '@/data/Party/long-term-options'

export const LongTermOptionsState = _ => ({
  analysisOptions: ANALYSIS_STATUS,
  longTermOptions: IMMIGRATION_OPTIONS,
})
